import { Component, OnInit, ElementRef, ChangeDetectorRef, ComponentFactoryResolver, ViewRef, ViewChild, ComponentRef, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityServiceForMedicalService } from '../../../services/utility-service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../store/state/app.state';
import { QuoteDataCaptureService, FormValidationsService, UtilService, SERVICE_END_POINT, AuthService } from 'src/app/shared';
import * as UserDataConfig from '../../../../user-details/config/user-data.config';
import { AlertModal } from 'src/app/model/alert';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { LifeStyleQuestion, HealthLifestyle, Sections } from '../../../model/lifestyle.model';
import { Subscription } from 'rxjs';
import { UnderWritingData, QuestionsToAPI, AnnuitantMedicalConditions } from '../../../model/lifestyle.post.model';
import { MandatoryQuestionsDirective } from 'src/app/pages/medical-underwriting/directives/mandatory-questions-directive'
import { ControlTypesComponent } from '../../control-types/control-types.component';
import { MedicalCondQuestionSet } from '../../../medical-underwrting.constants';
import { SyncService } from '../../../services/sync.service';
import { AdItem } from '../../ad-item.component';
import * as LifeStyleActions from '../../../store/actions/lifestyle.action';
import { MedicationQuestionStoreModel, SaveReturnModel, MedCondClassificationModel, SubAndClassificationModel, AccordBtnModel, InvalidCtlNameObj, TabQuesObjList, TabSquareMandatoryErrorModel } from '../../../model/mcUserJourney.model';
import { MEDICAL_UW_URL, MEDICAL_UW_HO_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { rangeData } from 'src/app/pages/medical-underwriting/model';
import { BackDataStoreModel, EditMedIndexModel } from '../../../model/mcUserJourney.model';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { AnalyticsService } from 'src/app/shared';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

const jsonFormat = ".json";
const MEDICATION = "Medication";

@Component({
  selector: 'app-diabetes-medical-condtion',
  templateUrl: './diabetes-medical-condtion.component.html',
  styleUrls: ['./diabetes-medical-condtion.component.scss']
})
export class DiabetesMedicalCondtionComponent implements OnInit {

  contentData: any;
  protected diabetesMCForm: UntypedFormGroup;
  private initialQuestionJson: string;
  public userInputDetail = UserDataConfig.ElementsConfig;
  displayAlert = false;
  displayPage = true;
  public alertDiabetesModalConfig: AlertModal;
  private sectionsList: Sections[] = [];
  private questionToDisplayForDCJMC: LifeStyleQuestion[];
  private medicalConditionPayload: QuestionsToAPI[];
  private backendQuesObjForAccordDepList: QuestionsToAPI[];
  allowStoresubscribe: boolean;
  private lifeStyleFromStoreObsSubscription: Subscription;
  private lifeStylePayloadFromStore: UnderWritingData;
  @ViewChild(MandatoryQuestionsDirective, { static: false }) mandatoryQuestionsDir: MandatoryQuestionsDirective;
  private componentRefOfControlType: ComponentRef<ControlTypesComponent>;
  public lifestyleForm: UntypedFormGroup;
  private underWritingData: UnderWritingData;
  private jsonObj: HealthLifestyle;
  public selectedTitle: string;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private invalidDataSubscription: Subscription;
  private indexToSearchFromStore: number;
  private isEditMode: boolean = false;
  private tabSquareToShowObj: TabSquareMandatoryErrorModel[] = [];
  // private isNewMedCondition: boolean = false;
  isHOView = false;
  saverAndReturnObj: SaveReturnModel;
  showAddAccordionBtn: boolean;
  disableAddAccordionBtnFlag: boolean;
  accordionQuesIdList: string;
  accordionQuesObj: LifeStyleQuestion;
  private lifeStylePayloadFromStoreObj: UnderWritingData;
  private radioBtnQuestionObj: LifeStyleQuestion;
  private totalMedCount: number;
  private currentIndex: number;
  private rangeValidationData: rangeData[];
  private errorText: string = '';
  url: string = '';
  singleRecurrence: boolean;
  medCurrentCount: number;
  private CMSData;
  private availableTabIdInPayload: boolean = false;
  dependantFlag: boolean = false;
  constructor(private fb: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public el: ElementRef,
    private cdRef: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private healthService: HealthService,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private syncService: SyncService,
    private store: Store<AppState>,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private utilService: UtilService,
    private analyticsService: AnalyticsService, private authService: AuthService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.diabetesMC;
    this.isHOView = this.router.url.includes('ho-underwriting') ? true : false;

    this.syncService.getEditMedConditionIndex().subscribe((res) => {
      if (res.editIndex) {
        this.isEditMode = true;
        this.indexToSearchFromStore = res.editIndex;
      }
    });

    this.syncService.getInitialQuestionJson().subscribe((res) => {
      // this.initialQuestionJson = "High_blood_pressure.json";//"Heart_disease.json";
      // this.selectedTitle = "High blood pressure";//"Heart";

      this.initialQuestionJson = res.jsonUrl;//"Heart_disease.json";
      this.selectedTitle = res.tittle;//"Heart";
      if (!this.isEditMode) {
        this.currentIndex = res.totalMedCondn;
        this.totalMedCount = res.totalMedCondn;
      }
    });
    this.lifeStyleFromStoreObsSubscription = this.store.select(STORE_VAL.lifestyle).subscribe(res => {
      if (res.length > 0) {
        this.lifeStylePayloadFromStoreObj = res[0];
      }
    });
    this.syncService.getRangeValidationJson().subscribe((res) => {
      this.rangeValidationData = res;
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.userInputDetail['buttonConfig']['label'] = 'Next';
    this.userInputDetail['buttonConfig']['name'] = 'Next';
    // this.alertDiabetesModalConfig = this.contentData.modalDiabetesMCConfig;
    this.syncService.assignDirectValueToMedicationQuestionList([]);
    this.syncService.setTabSquareAsActive([]);
    this.syncService.setAccordionBtnObj(null);
    this.syncService.setIndexToPrepareBackEndJson([]);
    this.syncService.setMCSubAndClassificationObjAsEmpty([]);
    this.initiateLifestyleFormData();
    this.configSaveComponent();

    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      // tslint:disable-next-line: max-line-length
      this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Return to Medical Conditions', pageID: this.utilService.getCurrentScreenName() });
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });

    this.invalidDataSubscription = this.utilService.invalidDataEvt.subscribe((invalidObj: InvalidCtlNameObj) => {
      this.handleInvalidData(invalidObj);
    });
  }

  ngAfterViewInit() {
    //this.getLifestyleData();
    this.getMedicalConditionJson();
  }

  initiateLifestyleFormData = () => {
    this.lifestyleForm = this.fb.group({

    });
  }

  configSaveComponent() {
    let url = this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.medicalConditions, MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions);
    this.saverAndReturnObj = new SaveReturnModel(true, url);
  }

  getMedicalConditionJson() {
    this.healthService.getMedicalConditionJson(this.initialQuestionJson)
      .subscribe(res => {
        let questionToDisplayObj: LifeStyleQuestion[] = [];
        this.jsonObj = res;
        this.sectionsList = this.jsonObj.section;
        this.syncService.setMedicalConditionJson(this.sectionsList);
        this.sectionsList.forEach(sec => {
          let temp = sec.question.filter(res => res.dcjCustomerDisplay === 'Yes' && res.mandatoryInitialDisplay === 'Yes');
          temp.forEach(ques => {
            ques.sectionNameToRefer = sec.sectionName;
            questionToDisplayObj.push(ques);
          });
        });
        this.questionToDisplayForDCJMC = questionToDisplayObj;
        this.allowStoresubscribe = true;
        this.getQuestionToDisplayForDCJMC();
        if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
          this.cdRef.detectChanges();
        }
      });
  }

  returnIndexForMatchingMC(medicalConditionsFromStore: AnnuitantMedicalConditions[]): number {
    let indexValue: number = 0;
    medicalConditionsFromStore.forEach(element => {
      if (element.questionSetName === this.jsonObj.questionSetName && element.index > indexValue) {
        indexValue = element.index;
      }
    });
    return indexValue;
  }
  getQuestionToDisplayForDCJMC() {

    this.lifeStyleFromStoreObsSubscription = this.store.select(STORE_VAL.lifestyle).subscribe(res => {
      if (this.allowStoresubscribe) {
        if (res.length > 0) {
          this.lifeStylePayloadFromStore = res[0];
          if (this.lifeStylePayloadFromStore && (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant' && this.lifeStylePayloadFromStore.annuitantMedicalConditions
            && this.lifeStylePayloadFromStore.annuitantMedicalConditions.length > 0)) {
            // this.indexToSearchFromStore = !(this.isEditMode) ? this.returnIndexForMatchingMC(this.lifeStylePayloadFromStore.annuitantMedicalConditions) : this.indexToSearchFromStore;
            this.syncService.setPayLoadObjAndIndexFromStore(this.lifeStylePayloadFromStore, this.indexToSearchFromStore);
            this.renderUIBasedOnSelectedresponseValue();
            this.loadComponent(this.questionToDisplayForDCJMC);
          } else if (this.lifeStylePayloadFromStore && (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant' && this.lifeStylePayloadFromStore.dependentMedicalConditions
            && this.lifeStylePayloadFromStore.dependentMedicalConditions.length > 0)) {
            // this.indexToSearchFromStore = !(this.isEditMode) ? this.returnIndexForMatchingMC(this.lifeStylePayloadFromStore.dependentMedicalConditions) : this.indexToSearchFromStore;
            this.syncService.setPayLoadObjAndIndexFromStore(this.lifeStylePayloadFromStore, this.indexToSearchFromStore);
            this.renderUIBasedOnSelectedresponseValue();
            this.loadComponent(this.questionToDisplayForDCJMC);
          }
          else {
            //this.renderUIWithDefaultValues(); 
          }

        }
        else {
          this.renderUIWithDefaultValues();
          this.loadComponent(this.questionToDisplayForDCJMC);
        }
      }
    });

  }

  renderUIWithDefaultValues() {
  }

  renderUIBasedOnSelectedresponseValue() {
    this.addResponseValueByUserToQuestionsList();

    // TODO: partial - quotes- go through json again whre next step values found and trigger the user action function();

  }

  getAnswerFromStore(questionId: string): QuestionsToAPI {
    let value: QuestionsToAPI;
    value = this.utilityServiceForMedicalService.getResponseValuesFromStore(questionId, this.lifeStylePayloadFromStore, this.indexToSearchFromStore);
    return value;
  }

  addResponseValueByUserToQuestionsList() {
    this.sectionsList.forEach(sec => {
      sec.question.forEach(qus => {
        let temp = this.getAnswerFromStore(qus.id);
        qus.responseValueByUser = temp ? temp.responseValue : undefined;
        // qus.defaultResponseValue = qus.responseValueByUser;
      });
    });
  }

  showOrHideAccordionAddBtn(questionList: LifeStyleQuestion[]): void {
    let result = questionList.find((item) => (item.controlStyle === "Accordion_standard"));
    this.accordionQuesObj = result;
    this.showAddAccordionBtn = false;
    if (result) {
      this.accordionQuesIdList = result.id;
      this.showAddAccordionBtn = true;
      let tempSRecurrence = this.utilityServiceForMedicalService.getSecRecurrenceNumber(this.accordionQuesObj.id, null);
      let maxLimit = Number(tempSRecurrence);
      let temp = new AccordBtnModel(1, maxLimit, 0);
      this.syncService.setAccordionBtnObj(temp);
      this.disableAddAccordBtn();
    }
  }

  disableAddAccordBtn(): void {
    this.disableAddAccordionBtnFlag = false;
    let temp = this.syncService.getAccordionBtnObj();
    if (temp && temp.maxNumberOfAccord <= temp.numberOfAccord) {
      this.disableAddAccordionBtnFlag = true;
    }
  }

  @HostListener('document:AddBtnDisableEvt', ['$event'])
  deleteAccordionEventListener(event) {
    this.disableAddAccordBtn();
  }

  addAnotherAccordion() {
    let addAccordionEvent = new CustomEvent("addAccordionEvent", null);
    document.dispatchEvent(addAccordionEvent);
  }

  loadComponent(questionList: LifeStyleQuestion[]) {
    this.showOrHideAccordionAddBtn(questionList);
    const adItem = new AdItem(ControlTypesComponent, {});
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(adItem.component);
    const viewContainerRef = this.mandatoryQuestionsDir.viewContainerRef;
    viewContainerRef.clear();
    this.componentRefOfControlType = viewContainerRef.createComponent(ControlTypesComponent);
    this.componentRefOfControlType.instance.controlTypeQuestionList = questionList;
    this.componentRefOfControlType.instance.lifeStylePayloadFromStoreObj = this.lifeStylePayloadFromStore;
    this.componentRefOfControlType.instance.parentForm = this.lifestyleForm;
    this.componentRefOfControlType.instance.indexStoredInUWDataObj = this.indexToSearchFromStore;
    let obj = new ParentFormAndElmModel(this.componentRefOfControlType.instance.parentForm, this.el,
      this.componentRefOfControlType.instance.cdRef, null);
    obj.emitInvalidEvtFlag = true;
    this.utilService.setParentFormToValidate(obj);
  }


  addMedicalCondtion() {
    this.clearBackData();
    this.clearEditMedIndex();
    if (this.isHOView) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.AMC, MEDICAL_UW_HO_URL.dependant.dependantAMC)]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.AMC, MEDICAL_UW_URL.dependant.dependantAMC)]);
    }
  }

  clearBackData() {
    const tempBackDataStoreModelObj = new BackDataStoreModel();
    tempBackDataStoreModelObj.currentIndex = null;
    tempBackDataStoreModelObj.isEdit = null;
    tempBackDataStoreModelObj.selectedMedCondn = "";
    //console.log("tempBackDataStoreModelObj Diabetes Screen", tempBackDataStoreModelObj);
    this.syncService.setBackNavData(tempBackDataStoreModelObj);
  }

  clearEditMedIndex() {
    const tempEditMedIndexModelObj = new EditMedIndexModel();
    tempEditMedIndexModelObj.editIndex = null;
    this.syncService.setEditMedConditionIndex(tempEditMedIndexModelObj);
  }

  saveAndReturnToMedCondn() {
    if (this.isHOView) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.medicalConditions, MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions)]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.medicalConditions, MEDICAL_UW_URL.dependant.dependantMedicalConditions)]);
    }

  }

  closeModal() {
    this.displayAlert = false;
  }

  closePage() {
    this.displayPage = false;
    if (this.isHOView) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.medicalConditions, MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions)]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.medicalConditions, MEDICAL_UW_URL.dependant.dependantMedicalConditions)]);
    }
  }

  navigateToMedicalCondition() {
    if (this.isHOView) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.medicalConditions, MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions)]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.medicalConditions, MEDICAL_UW_URL.dependant.dependantMedicalConditions)]);
    }
  }

  saveFormValues() {
    //console.log(this.medicalConditionPayload);
    this.underWritingData = new UnderWritingData();

    /*  if (!this.lifeStylePayloadFromStore) {
       this.lifeStylePayloadFromStore = new UnderWritingData();
       this.lifeStylePayloadFromStore.annuitantMedicalConditions = [];
       this.lifeStylePayloadFromStore.dependentMedicalConditions = [];
     } */

    this.underWritingData.annuitantMedicalConditions = this.lifeStylePayloadFromStore.annuitantMedicalConditions ? this.lifeStylePayloadFromStore.annuitantMedicalConditions : [];
    this.underWritingData.dependentMedicalConditions = this.lifeStylePayloadFromStore.dependentMedicalConditions ? this.lifeStylePayloadFromStore.dependentMedicalConditions : [];
    this.underWritingData.riskAndStaticQuestion = this.lifeStylePayloadFromStore.riskAndStaticQuestion ? this.lifeStylePayloadFromStore.riskAndStaticQuestion : null;

    if ((this.checkMedStatus() && (this.currentIndex === this.totalMedCount)) || this.isEditMode) {
      this.currentIndex = this.currentIndex + 1;
    } else {
      this.isEditMode = true;
      this.currentIndex = this.currentIndex + 1;
      this.indexToSearchFromStore = this.totalMedCount + 1;
    }

    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
      if (this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.annuitantMedicalConditions
        && this.lifeStylePayloadFromStore.annuitantMedicalConditions.length > 0) {
        if (this.isEditMode) {
          this.lifeStylePayloadFromStore.annuitantMedicalConditions.forEach((element, index) => {
            if (element.index === this.indexToSearchFromStore) {
              // element.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload);
              // element.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload);
              element = { ...element, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload) };
              element = { ...element, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload) };
              // console.log("Check:::::" + element.status);
              // console.log(element.questions);
              let annuitantMeds = [...this.lifeStylePayloadFromStore.annuitantMedicalConditions];
              annuitantMeds[index] = element;
              this.lifeStylePayloadFromStore = { ...this.lifeStylePayloadFromStore, annuitantMedicalConditions: annuitantMeds };
              // this.lifeStylePayloadFromStore.annuitantMedicalConditions[index] = element;
            }
          });
          //this.underWritingData.annuitantMedicalConditions = this.lifeStylePayloadFromStore.annuitantMedicalConditions;
          this.underWritingData = { ...this.underWritingData, annuitantMedicalConditions: this.lifeStylePayloadFromStore.annuitantMedicalConditions };
        } else {
          let tempAnnuitantMed: AnnuitantMedicalConditions = new AnnuitantMedicalConditions();
          // tempAnnuitantMed.questionSetName = this.jsonObj.questionSetName;
          // tempAnnuitantMed.index = this.lifeStylePayloadFromStore.annuitantMedicalConditions.length;
          // tempAnnuitantMed.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload);
          // tempAnnuitantMed.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload);

          tempAnnuitantMed = { ...tempAnnuitantMed, questionSetName: this.jsonObj.questionSetName };
          tempAnnuitantMed = { ...tempAnnuitantMed, index: this.lifeStylePayloadFromStore.annuitantMedicalConditions.length };
          tempAnnuitantMed = { ...tempAnnuitantMed, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload) };
          tempAnnuitantMed = { ...tempAnnuitantMed, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload) };

          // console.log("Check:::::" + tempAnnuitantMed.status);
          // console.log(tempAnnuitantMed.questions);

          let annuitantMeds = [...this.lifeStylePayloadFromStore.annuitantMedicalConditions];

          annuitantMeds.push(tempAnnuitantMed);

          this.lifeStylePayloadFromStore = { ...this.lifeStylePayloadFromStore, annuitantMedicalConditions: annuitantMeds };

          //this.underWritingData.annuitantMedicalConditions = this.lifeStylePayloadFromStore.annuitantMedicalConditions;

          this.underWritingData = { ...this.underWritingData, annuitantMedicalConditions: this.lifeStylePayloadFromStore.annuitantMedicalConditions };
        }
      }
    }
    else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
      if (this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.dependentMedicalConditions
        && this.lifeStylePayloadFromStore.dependentMedicalConditions.length > 0) {
        if (this.isEditMode) {
          this.lifeStylePayloadFromStore.dependentMedicalConditions.forEach((element, index) => {
            if (element.index === this.indexToSearchFromStore) {
              // element.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload);
              // element.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload);
              element = { ...element, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload) };
              element = { ...element, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload) };
              let dependantMeds = [...this.lifeStylePayloadFromStore.dependentMedicalConditions];
              dependantMeds[index] = element;
              this.lifeStylePayloadFromStore = { ...this.lifeStylePayloadFromStore, dependentMedicalConditions: dependantMeds };
              // this.lifeStylePayloadFromStore.dependentMedicalConditions[index] = element;
            }
          });
          //this.underWritingData.dependentMedicalConditions = this.lifeStylePayloadFromStore.dependentMedicalConditions;
          this.underWritingData = { ...this.underWritingData, dependentMedicalConditions: this.lifeStylePayloadFromStore.dependentMedicalConditions };
        } else {
          let tempDependantMed: AnnuitantMedicalConditions = new AnnuitantMedicalConditions();
          // tempDependantMed.questionSetName = this.jsonObj.questionSetName;
          // tempDependantMed.index = this.lifeStylePayloadFromStore.dependentMedicalConditions.length;
          // tempDependantMed.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload);
          // tempDependantMed.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload);

          tempDependantMed = { ...tempDependantMed, questionSetName: this.jsonObj.questionSetName };
          tempDependantMed = { ...tempDependantMed, index: this.lifeStylePayloadFromStore.dependentMedicalConditions.length };
          tempDependantMed = { ...tempDependantMed, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload) };
          tempDependantMed = { ...tempDependantMed, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload) };

          // this.lifeStylePayloadFromStore.dependentMedicalConditions.push(tempDependantMed);
          // this.underWritingData.dependentMedicalConditions = this.lifeStylePayloadFromStore.dependentMedicalConditions;

          let dependantMeds = [...this.lifeStylePayloadFromStore.dependentMedicalConditions];

          dependantMeds.push(tempDependantMed);

          this.lifeStylePayloadFromStore = { ...this.lifeStylePayloadFromStore, dependentMedicalConditions: dependantMeds };

          //this.underWritingData.annuitantMedicalConditions = this.lifeStylePayloadFromStore.annuitantMedicalConditions;

          this.underWritingData = { ...this.underWritingData, dependentMedicalConditions: this.lifeStylePayloadFromStore.dependentMedicalConditions };
        }
      }
    }
    if (this.underWritingData && this.underWritingData.annuitantMedicalConditions && this.underWritingData.annuitantMedicalConditions.length > 0) {
      this.underWritingData = { ...this.underWritingData, annuitantMedicalConditions: this.utilityServiceForMedicalService.sortMedicalConditions(this.underWritingData.annuitantMedicalConditions) }

    }
    if (this.underWritingData && this.underWritingData.dependentMedicalConditions && this.underWritingData.dependentMedicalConditions.length > 0) {
      this.underWritingData = { ...this.underWritingData, dependentMedicalConditions: this.utilityServiceForMedicalService.sortMedicalConditions(this.underWritingData.dependentMedicalConditions) }

    }
    this.store.dispatch(new LifeStyleActions.RemoveLifestyleResult(0));
    this.store.dispatch(new LifeStyleActions.AddLifestyleResult(this.underWritingData));
  }

  triggerPostQuotesAPI(isbackBtnClicked: boolean) {
    this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {

      if (isbackBtnClicked) {
        //this.router.navigate(['/home/your-product-choice']);
      }
      else {
        this.displayAlert = true;
        // this.router.navigate([MEDICAL_UW_URL.annuitant.AMC]);
        //this.router.navigate([MEDICAL_UW_URL.annuitant.medicalConditions]);
        //this.router.navigate(['/home/your-dependant']);
      }
    },
      err => {

      });
  }

  preparePayload(isbackBtnClicked: boolean) {
    this.saveFormValues();
    this.triggerPostQuotesAPI(isbackBtnClicked);
  }

  prepareBackendJsonForTabSquare(quesObj: LifeStyleQuestion) {
    if (quesObj.nextStep && quesObj.nextStep.length > 0 && quesObj.controlStyle === "Tab_square") {
      let backendQuestionObjForMandatoryQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, quesObj, null);
      backendQuestionObjForMandatoryQues.recurrenceInd = true;
      backendQuestionObjForMandatoryQues.questionModels = [];

      let recurrenceQuesListToApi: QuestionsToAPI[] = [];
      let recurrenceQuesListFromUIStoreForGivenQues: MedicationQuestionStoreModel[] = this.utilityServiceForMedicalService.getRecurrenceListForGivenQues(quesObj, null);
      recurrenceQuesListFromUIStoreForGivenQues.forEach(recQuesObjFromStore => {
        recQuesObjFromStore.questionList.forEach(storeObj => {
          recurrenceQuesListToApi.push(storeObj);
        });
      });
      backendQuestionObjForMandatoryQues.questionModels = recurrenceQuesListToApi;
      this.medicalConditionPayload.push(backendQuestionObjForMandatoryQues);
    }
  }

  prepareBackendJsonForAccordionQues(quesObj: LifeStyleQuestion) {
    if (quesObj.nextStep && quesObj.nextStep.length > 0 && quesObj.controlStyle === "Accordion_standard") {
      let backendQuesObjForAccord: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, quesObj, null);
      backendQuesObjForAccord.recurrenceInd = true;
      backendQuesObjForAccord.questionModels = [];

      this.backendQuesObjForAccordDepList = [];
      let count = 0;
      let nextQuestionIdList: string[] = [];
      quesObj.nextStep.forEach(element => {
        element.nextStepValue.forEach(quesId => {
          nextQuestionIdList.push(quesId);
        });
      });
      let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(nextQuestionIdList, null);
      let indexListToLookFor = this.syncService.getAccordIndexToPrepareBackEndJson();
      if (indexListToLookFor && indexListToLookFor.length > 0) {
        do {
          let indexToScanAngularForm;
          if (indexListToLookFor && indexListToLookFor.length > 0) {
            indexToScanAngularForm = indexListToLookFor[count];
          }
          let prefix = 'A' + indexToScanAngularForm + '-';
          nextQuestionObjList.forEach(nextQuestionObj => {
            let referenceQueId: string = quesObj.id;
            let backendObj: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, nextQuestionObj, prefix);
            backendObj.index = count.toString();
            this.backendQuesObjForAccordDepList.push(backendObj);
            this.recursiveFunForDependentQuestion(backendObj.responseValue, nextQuestionObj, null, prefix, true, count);

          });
          count = count + 1;
        }
        while (count < (indexListToLookFor.length))
      }

      backendQuesObjForAccord.questionModels = this.backendQuesObjForAccordDepList;
      this.medicalConditionPayload.push(backendQuesObjForAccord);
    }
  }

  removeUnwantedFormBasedOnPayload() {
    let quesIdListToSend: string[];
    quesIdListToSend = this.utilityServiceForMedicalService.getQuesIdListToSend(this.medicalConditionPayload, this.accordionQuesIdList);
    this.utilityServiceForMedicalService.removeUnwantedFormControl(quesIdListToSend, null, this.lifestyleForm);
    this.syncService.emitEventForBusinessValidation(null);
  }

  extractFromFormObjAndPrepareBackendJson() {
    this.medicalConditionPayload = [];
    let tempActiveTabList = this.syncService.getTabSquareAsActive();
    if (tempActiveTabList && tempActiveTabList.length > 0) {
      tempActiveTabList.forEach(tab => {
        if (tab.isActive && tab.nextQuestionObjList) {
          let accordPrefix = tab.accordPrefix;
          this.utilityServiceForMedicalService.prepareCurrentActiveFormTabSquare(this.lifestyleForm, tab.nextQuestionObjList, tab.activeIndex, tab.tabQuestionId, null, accordPrefix);
          // need to write logic to find the current tabindex and needs to be added in the recurance list
        }
      });

    }

    this.questionToDisplayForDCJMC.forEach(mandatoryQuesObj => {
      if (mandatoryQuesObj.nextStep && mandatoryQuesObj.nextStep.length > 0 && mandatoryQuesObj.controlStyle === "Tab_square") {
        this.prepareBackendJsonForTabSquare(mandatoryQuesObj);
      }
      else if (mandatoryQuesObj.nextStep && mandatoryQuesObj.nextStep.length > 0 && mandatoryQuesObj.controlStyle === "Accordion_standard") {
        this.prepareBackendJsonForAccordionQues(mandatoryQuesObj);
      }
      else {
        let backendQuestionObjForMandatoryQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, mandatoryQuesObj, null);
        this.medicalConditionPayload.push(backendQuestionObjForMandatoryQues);
        let selectedValueForMandatoryQues = backendQuestionObjForMandatoryQues.responseValue;
        this.recursiveFunForDependentQuestion(selectedValueForMandatoryQues, mandatoryQuesObj, null, null, null, null);
      }
    });
    //console.log(this.medicalConditionPayload);
    this.removeUnwantedFormBasedOnPayload();
  }

  recursiveFunForDependentQuestion(selectedValueForMandatoryQues: any, quesObj: LifeStyleQuestion,
    jsonToReferFromRec: string, prefix: string, isAccordion: true, indexForAccordion: number) {
    if (typeof selectedValueForMandatoryQues === 'string' && selectedValueForMandatoryQues && quesObj.responseValue && quesObj.responseValue.length > 0) {
      // for the values where response value can be one. like input , number, radiobtn (yes/no)
      this.prepareForDepQuestionsForResValueAsString(quesObj, selectedValueForMandatoryQues, jsonToReferFromRec, prefix, isAccordion, indexForAccordion);
    }
    if (selectedValueForMandatoryQues === null && quesObj.responseValue === null && quesObj.nextStep && quesObj.nextStep.length > 0) {
      //  for dummy questions but it can contains nextstep questions. eg: grid
      this.prepareForDepQuestionsForResValueAsNull(quesObj, jsonToReferFromRec, prefix, isAccordion, indexForAccordion);
    }
    /* if (Array.isArray(selectedValue) && mandatoryQuesObj.nextStep && mandatoryQuesObj.nextStep.length > 0) { //  for question which can have dummy questions but it can contains nextstep questions
      this.prepareForDepQuestionsForResValueAsNull(mandatoryQuesObj, payload);
    } */
  }

  prepareForDepQuestionsForResValueAsNull(quesObj: LifeStyleQuestion, jsonToReferFromRec: string,
    prefix: string, isAccordion: true, indexForAccordion: number) {
    let questionIdList: string[] = [];


    if (quesObj.nextStep && quesObj.nextStep.length > 0 && quesObj.controlStyle !== "Tab_square") {
      quesObj.nextStep.forEach(next => {
        if (next.nextStepValue) {
          next.nextStepValue.forEach(id => {
            questionIdList.push(id);
          });
        }
      });
      let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(questionIdList, jsonToReferFromRec);
      nextQuestionObjList.forEach(nextQuestionObj => {
        let referenceQueId: string = quesObj.id;
        let backendQuestionObjForDependentQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, nextQuestionObj, prefix);
        if (isAccordion) {
          this.backendQuesObjForAccordDepList.push(backendQuestionObjForDependentQues);
        }
        else {
          this.medicalConditionPayload.push(backendQuestionObjForDependentQues);
        }
        if (backendQuestionObjForDependentQues.responseValue) {
          this.recursiveFunForDependentQuestion(backendQuestionObjForDependentQues.responseValue, nextQuestionObj, null, prefix, isAccordion, indexForAccordion);
        }
      });
    }
    else if (quesObj.nextStep && quesObj.nextStep.length > 0 && quesObj.controlStyle === "Tab_square") {

      let tempQuesnID: LifeStyleQuestion[] = [];
      tempQuesnID.push(quesObj);
      tempQuesnID.forEach(quesObj => {
        let backendQuestionObjForMandatoryQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, quesObj, prefix);
        backendQuestionObjForMandatoryQues.recurrenceInd = true;
        backendQuestionObjForMandatoryQues.questionModels = [];

        let recurrenceQuesListToApi: QuestionsToAPI[] = [];
        let recurrenceQuesListFromUIStoreForGivenQues: MedicationQuestionStoreModel[] = this.utilityServiceForMedicalService.getRecurrenceListForGivenQues(quesObj, prefix);
        recurrenceQuesListFromUIStoreForGivenQues.forEach(recQuesObjFromStore => {
          recQuesObjFromStore.questionList.forEach(storeObj => {
            recurrenceQuesListToApi.push(storeObj);
          });
        });
        backendQuestionObjForMandatoryQues.questionModels = recurrenceQuesListToApi;
        if (isAccordion) {
          backendQuestionObjForMandatoryQues.index = indexForAccordion.toString();
          this.backendQuesObjForAccordDepList.push(backendQuestionObjForMandatoryQues);
        }
        else {
          this.medicalConditionPayload.push(backendQuestionObjForMandatoryQues);
        }
      });
    }
  }

  prepareForDepQuestionsForResValueAsString(quesObj: LifeStyleQuestion, selectedValue: string,
    jsonToReferFromRec: string, prefix: string, isAccordion: true, indexForAccordion: number) {
    let questionIdList: string[] = [];
    if (quesObj.responseMethod === "opendictionary=MedConditions.json") {
      let quesIdWithPrefix = prefix ? (prefix + quesObj.id) : quesObj.id;
      let temp: SubAndClassificationModel = this.syncService.getMCSubAndClassificationObj(quesIdWithPrefix);
      selectedValue = temp ? temp.classificationValue : "";
    }
    if (quesObj.nextStep) {
      quesObj.nextStep.forEach(next => {
        if (next.nextStepSelectedResponse === selectedValue && next.nextStepValue && next.nextStepType === 'Question') {
          let nextQuestionIdList: string[] = next.nextStepValue;
          let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(nextQuestionIdList, jsonToReferFromRec);
          nextQuestionObjList.forEach(nextQuestionObj => {

            let referenceQueId: string = quesObj.id;
            let backendQuestionObjForDependentQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, nextQuestionObj, prefix);
            if (nextQuestionObj.controlStyle !== "Tab_square") { // Tab square question obj created along with its own question
              //eg: DIQ029" is added two times in the payload . so we are not pushing the payload in this block if the tab square found
              if (isAccordion) {
                backendQuestionObjForDependentQues.index = indexForAccordion.toString();
                this.backendQuesObjForAccordDepList.push(backendQuestionObjForDependentQues);
              }
              else {
                this.medicalConditionPayload.push(backendQuestionObjForDependentQues);
              }
            }
            this.recursiveFunForDependentQuestion(backendQuestionObjForDependentQues.responseValue, nextQuestionObj, null, prefix, isAccordion, indexForAccordion);
          });
        }
      });
    }
    else if (!quesObj.nextStep && quesObj.responseMethod && (selectedValue.toUpperCase() === "YES")) {
      let medJsonResponse: string[] = [];
      medJsonResponse[0] = quesObj.responseMethod;
      let tempQuestIds: string[] = medJsonResponse;
      if (tempQuestIds && tempQuestIds.length > 0 && tempQuestIds[0].includes(jsonFormat)) {
        let jsonToRefer = tempQuestIds[0];
        let tempList = this.syncService.getRefJsonWithMappingQId();
        // recurrence logic starting here with MDQ001 from medication json
        tempList.forEach(element => {
          if (element.questionId === quesObj.id) {
            element.questionList.forEach(quesObj => {
              let backendQuestionObjForMandatoryQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, quesObj, prefix);
              backendQuestionObjForMandatoryQues.recurrenceInd = true;
              backendQuestionObjForMandatoryQues.questionModels = [];

              let recurrenceQuesListToApi: QuestionsToAPI[] = [];
              let recurrenceQuesListFromUIStoreForGivenQues: MedicationQuestionStoreModel[] = this.utilityServiceForMedicalService.getRecurrenceListForGivenQues(quesObj, prefix);
              recurrenceQuesListFromUIStoreForGivenQues.forEach(recQuesObjFromStore => {
                recQuesObjFromStore.questionList.forEach(storeObj => {
                  recurrenceQuesListToApi.push(storeObj);
                });
              });
              backendQuestionObjForMandatoryQues.questionModels = recurrenceQuesListToApi;
              if (isAccordion) {
                backendQuestionObjForMandatoryQues.index = indexForAccordion.toString();
                this.backendQuesObjForAccordDepList.push(backendQuestionObjForMandatoryQues);
              }
              else {
                this.medicalConditionPayload.push(backendQuestionObjForMandatoryQues);
              }
            });

          }
        });
      }
    }
  }

  emitTabSquareValidationEvent() {
    this.utilityServiceForMedicalService.emitTabSquareValidationEvent();
  }
  emitTabSquareMandatoryEvt() {
    let tabSquareMandatoryEvt = new CustomEvent("tabSquareMandatoryEvt", { detail: this.tabSquareToShowObj });
    document.dispatchEvent(tabSquareMandatoryEvt);
  }

  emitAccordionValidationEvent() {
    this.utilityServiceForMedicalService.emitAccordionValidationEvent(this.lifestyleForm);
  }

  clearAccordionErrorMsg() {
    let clearAccordionErrorMsgEvt = new CustomEvent("clearAccordionErrorMsgEvt");
    document.dispatchEvent(clearAccordionErrorMsgEvt);
  }
  checkIfAllTabSquareMandatoryAnswered(): boolean {
    let tabObjList: TabQuesObjList[] = this.syncService.getMedicationQuestionList();
    let allMandatoryAreAnswered: boolean = true;
    this.tabSquareToShowObj = [];
    tabObjList.forEach(element => {
      element.quesListToStore.forEach(item => {
        let objToAdd = null;
        let indexList: string[] = [];
        item.questionList.forEach(quesObj => {
          if ((quesObj.mandatoryResponse && quesObj.mandatoryResponse.toUpperCase() === "YES")
            && (quesObj.responseValue === "" || quesObj.responseValue === null)) {
            indexList.push(quesObj.index);
          }
        });
        if (indexList.length > 0) {
          objToAdd = new TabSquareMandatoryErrorModel(item.medQuesId, indexList);
          let idToSearch = item.medQuesId;
          if (item.medQuesId.includes("A")) { // heart conditions
            let temp = item.medQuesId.split("-");
            idToSearch = temp[1];
          }
          if (this.isAvailableInPayloadRec(idToSearch)) {
            this.tabSquareToShowObj.push(objToAdd);
          }
        }
      });

    });
    if (this.tabSquareToShowObj && this.tabSquareToShowObj.length > 0) {
      allMandatoryAreAnswered = false;
      this.emitTabSquareMandatoryEvt();
    }
    return allMandatoryAreAnswered;
  }

  isAvailableInPayloadRec(medQuesId: string): boolean {
    this.availableTabIdInPayload = false;
    for (let item in this.medicalConditionPayload) {
      if (this.medicalConditionPayload[item].id === medQuesId) {
        this.availableTabIdInPayload = true;
        break;
      }
      else if (this.medicalConditionPayload[item].questionModels && this.medicalConditionPayload[item].questionModels.length > 0) {
        for (let temp in this.medicalConditionPayload[item].questionModels) {
          if (this.medicalConditionPayload[item].questionModels[temp].id === medQuesId) {
            this.availableTabIdInPayload = true;
            break;
          }
        }
      }
    }
    return this.availableTabIdInPayload;
  }
  gotoNext = () => {

    this.emitTabSquareValidationEvent();
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    if (this.componentRefOfControlType.instance.validateForm() && this.checkIfAllTabSquareMandatoryAnswered()) { //this.componentRefOfControlType.instance.validateForm() validation logic will be applied here
      // this.displayAlert = true;
      this.allowStoresubscribe = false;
      this.preparePayload(false);
    } else {
      if (this.showAddAccordionBtn) { // when form is invalid and accordion found, we need to highlight the invalid accordion
        this.clearAccordionErrorMsg();
        this.emitAccordionValidationEvent();
      }
      this.displayAlert = false;
      this.componentRefOfControlType.instance.throwValidation(this.lifestyleForm);
    }
  }

  checkMedStatus(): boolean {
    let count: number = 0;
    let medStatus: boolean;
    this.rangeValidationData.forEach(element => {
      if (element.valueKey === this.selectedTitle) {
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
          count = this.getCount(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions, this.selectedTitle);
        } else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
          count = this.getCount(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions, this.selectedTitle);
        }
        if (count < +element.valueMax) {
          medStatus = true;
        } else {
          medStatus = false;
        }
      }
    });
    return medStatus;
  }

  getCount(dataToBeSearched, selectedValue: string) {
    let count: number = 0;
    dataToBeSearched.forEach(element => {
      if (element.questionSetName === selectedValue) {
        count++;
      }
    });
    this.medCurrentCount = count;
    return count;
  }

  onBackClick() {
    const tempBackDataStoreModelObj = new BackDataStoreModel();
    if (this.checkMedStatus() && !this.indexToSearchFromStore) {
      tempBackDataStoreModelObj.currentIndex = this.totalMedCount + 1;
    } else {
      tempBackDataStoreModelObj.currentIndex = this.indexToSearchFromStore;
    }
    tempBackDataStoreModelObj.isEdit = true;
    tempBackDataStoreModelObj.selectedMedCondn = this.selectedTitle;
    this.syncService.setBackNavData(tempBackDataStoreModelObj);
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
  }

  saveAfterLogin() {
    this.allowStoresubscribe = false;
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully()
    );
  }

  saveAfterLogout() {
    this.allowStoresubscribe = false;
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }

  saveProgress() {
    this.allowStoresubscribe = false;
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.saveAndReturnToMedCondn();
    });
  }

  handleInvalidData(invalidObj: InvalidCtlNameObj) {
    this.emitTabSquareValidationEvent();
    if (invalidObj && invalidObj.invalidDataPresent) {
      this.componentRefOfControlType.instance.throwValidationForOneCtl(this.lifestyleForm, invalidObj.ctlName);
    }
  }

  /*   checkIfAnyInvalidDataPresent(): boolean {
      this.emitTabSquareValidationEvent();
      let invalidDataPresent = false;
      let obj: InvalidCtlNameObj = this.utilityServiceForMedicalService.isInvalidDataFoundInForm(this.lifestyleForm);
      if (obj && obj.invalidDataPresent) {
        invalidDataPresent = obj.invalidDataPresent;
        this.componentRefOfControlType.instance.throwValidationForOneCtl(this.lifestyleForm, obj.ctlName);
      } else {
        invalidDataPresent = false;
      }
      return invalidDataPresent;
    } */

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }

  ngOnDestroy() {
    if (this.lifeStyleFromStoreObsSubscription) {
      this.lifeStyleFromStoreObsSubscription.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.invalidDataSubscription) {
      this.invalidDataSubscription.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    //console.log('changed value = ', this.contentData);
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_MedicalDetailsCapture;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.introduction = this.CMSData.string_MedicalDetailsCaptureSubitleNotADL;
        this.alertDiabetesModalConfig = new AlertModal("alert", this.CMSData.string_ConditionAddedMessageTitle,
          this.CMSData.string_ConditionAddedMessage, this.CMSData.string_ConditionAddedMessageAddCTALabel, "",
          this.CMSData.string_ConditionAddedMessageNoOtherCTALabel);
        if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
          this.dependantFlag = true;
          this.contentData.subTitle = this.CMSData.string_DependantPage;
        }
      }
    });
  }
  /** End of code block for CMS */
}
